export default "__VITE_ASSET__B7y0TB9R__"